import { CAMPAIGN_SEND_RAIL_LABELS } from '@marketing-hub/shared';
import type { Campaign } from '@/api/types';
import pageStyles from '@/pages/ProjectsPage.module.css';

type Props = {
  campaign: Campaign;
  hasBrevoIntegration: boolean;
};

/** F7 — cold sequence via Brevo transactional (no SMTP mailbox). */
export function CampaignSequenceSendRailPanel({ campaign, hasBrevoIntegration }: Props) {
  if (campaign.type === 'broadcast') return null;

  const rail = campaign.send_rail ?? 'smtp';
  if (rail !== 'brevo_transactional') return null;

  return (
    <section className={pageStyles.card}>
      <h3>Sequence via Brevo transactional</h3>
      <p className={pageStyles.mutedSmall}>
        Deze campagne gebruikt <strong>{CAMPAIGN_SEND_RAIL_LABELS.brevo_transactional}</strong>.
        Stappen worden via de Brevo transactional API verstuurd (zelfde templates/merge als SMTP).
        Webhooks koppelen events aan <code>mail_messages</code> via mh-tags.
      </p>
      {!hasBrevoIntegration ? (
        <p className={pageStyles.mutedSmall} role="alert">
          Geen actieve Brevo-integratie — starten en verzenden mislukt tot Brevo is gekoppeld.
        </p>
      ) : null}
    </section>
  );
}
